import React, { FC }                                                                                                             from 'react';
import * as Yup                                                                                                                  from "yup";
import { BulkUpdateFormControlContainer }                                                                                        from "@src/views/pages/projects/activities/bulk/BulkUpdateFormControlContainer";
import { TextAreaField }                                                                                                         from "@src/views/components/forms";
import { ProjectActivityBulkUpdateShell, ProjectActivityBulkUpdateShellFormContainerProps, ProjectActivityBulkUpdateShellProps } from "@src/views/pages/projects/activities/bulk/ProjectActivityBulkUpdateShell";
import { ProjectActivityBulkUpdateMultiDialogProps }                                                                             from "@src/views/pages/projects/operations/ProjectActivityBulkUpdateMultiDialog";


type FormTypeAttributes = {
    notes: string | null
}

const formDefaultValues = {
    notes: ''
}

const validationSchema = (
    Yup.object().shape( {
        notes: Yup.string().nullable(),
    } )
)

const mutationAttributeFormatter: ProjectActivityBulkUpdateShellProps<FormTypeAttributes>['prepareFormValuesForMutation'] = ( values ) => {
    return {
        notes: ( `${ values.notes }` ).trim(),
    }
}

interface ProjectActivityBulkUpdateNotesProps
    extends Pick<ProjectActivityBulkUpdateShellProps<FormTypeAttributes>, 'supportModals' | 'supportToasts'>,
        Pick<ProjectActivityBulkUpdateMultiDialogProps, 'projectId' | 'projectVersionId' | 'projectActivityIds'> {
    formContainer: FC<ProjectActivityBulkUpdateShellFormContainerProps>
}

const ProjectActivityBulkUpdateNotesDefaultProps = {
    supportModals: false,
    supportToasts: true,
} satisfies Partial<ProjectActivityBulkUpdateNotesProps>

function ProjectActivityBulkUpdateNotes( _props: ProjectActivityBulkUpdateNotesProps ){

    const props = { ...ProjectActivityBulkUpdateNotesDefaultProps, ..._props };

    return (

        <ProjectActivityBulkUpdateShell<FormTypeAttributes>
            projectId={ props.projectId }
            projectVersionId={ props.projectVersionId }
            ids={ props.projectActivityIds }
            supportToasts={ props.supportToasts }
            supportModals={ props.supportModals }
            defaultFormValues={ formDefaultValues }
            validationSchema={ validationSchema }
            formContainer={ props.formContainer }
            prepareFormValuesForMutation={ mutationAttributeFormatter }>

            {/* FORM CONTENT */ }
            { ( { formik, isProcessing, isLoading } ) => (

                <BulkUpdateFormControlContainer
                    icon={ 'pencil' }
                    title={ 'Update Notes' }
                    description={ 'Migrate notes for multiple activities to the one specified. All notes will be overwritten.' }>

                    <TextAreaField
                        label={ 'Notes' }
                        descriptionText={ 'Apply notes to the selected activities.' }
                        name={ `notes` }
                        rows={ 8 }
                        disabled={ isLoading || isProcessing }
                    />

                </BulkUpdateFormControlContainer>

            ) }

        </ProjectActivityBulkUpdateShell>

    );
}

export {
    ProjectActivityBulkUpdateNotes,
    ProjectActivityBulkUpdateNotesDefaultProps,
    type ProjectActivityBulkUpdateNotesProps,
};
